﻿import FavoriteImagesApi from '../FavoriteImagesApi';

export function removeFavoriteImage(derivedOrderId: number, photoId: number) {
    return FavoriteImagesApi.removeFavoriteImage(derivedOrderId, photoId);
}